import React from 'react';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { loadable } from '@shared/core/loadableFromNamedExport';

// Reserved height empirically sized from the honeymoon stays-page first-paint band
// (Brannan header + hero + first content row). Honeymoon-only — non-redesign Custom
// pages don't render this lazy component (the dispatcher in CustomHoneymoon.router
// picks `CustomOriginal` for non-redesign events), so the fallback can't cause a
// shrink-shift on shorter non-honeymoon Custom pages.
//
// SSR behavior: `@loadable/server`'s `ChunkExtractor` synchronously resolves the
// component during SSR and renders the *real* component (not this fallback). The
// fallback only shows during client-side SPA navigation when this inner chunk
// (`guest/stays-page-honeymoon-custom`) isn't cached. The controller in
// `GuestSite.controller.ts` calls `LazyCustomHoneymoon.preload()` alongside
// `LazyCustom.preload()` for redesign events, which warms BOTH the outer router
// chunk AND this inner chunk. With both preloaded, the fallback is a safety net
// for cold-cache SPA navigation; otherwise it briefly reserves the 720px while
// the inner chunk fetches.
const RESERVED_FIRST_PAINT_HEIGHT_PX = 720;

const SectionShellFallback = (
  <Box
    width="100%"
    minHeight={pxToRem(RESERVED_FIRST_PAINT_HEIGHT_PX)}
    backgroundColor="mono1"
    aria-hidden="true"
  />
);

export const LazyCustomHoneymoon = loadable(() => import(/* webpackChunkName: "guest/stays-page-honeymoon-custom" */ './CustomHoneymoon'), 'CustomHoneymoon', {
  fallback: SectionShellFallback,
});
